import React from "react";
import OptionButton from "./OptionButton";

const QuestionOption = ({
  question,
  options,
  total,
  current,
  onClick,
  isSelecting,
}) => {
  return (
    <div>
      <p style={styles.questionLabel}>
        QUESTION {current}/{total}
      </p>

      <h2 style={styles.questionText}>{question.question}</h2>

      <p style={styles.optionsLabel}>CHOOSE ANY ONE OPTION BELOW</p>

      <div style={styles.optionsList}>
        {options.map((option, index) => (
          <OptionButton
            key={option.id}
            option={option}
            onClick={() => onClick(question.id, option.id)}
            isSelecting={isSelecting}
            label={String.fromCharCode(65 + index)}
          />
        ))}
      </div>
    </div>
  );
};

const styles = {
  questionLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: "#888",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 10,
    margin: 0,
  },
  questionText: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1a1a1a",
    lineHeight: 1.5,
    margin: "8px 0 16px",
  },
  optionsLabel: {
    fontSize: 10,
    fontWeight: 600,
    color: "#aaa",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: 12,
  },
  optionsList: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
};

export default QuestionOption;
